export const Krupki = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.419840233040418, 54.23482848344787],
            [29.40829057634909, 54.23354268045051],
            [29.393980529777764, 54.22852399038999],
            [29.387111707639292, 54.22618172590609],
            [29.3756636707418, 54.22450859839313],
            [29.370512053688515, 54.22484322983121],
            [29.35620200711702, 54.227854785969726],
            [29.349333184978548, 54.23120070105165],
            [29.3447539702197, 54.234546345437536],
            [29.34418156792509, 54.23922979162165],
            [29.347043577599095, 54.24123682032308],
            [29.355057203427293, 54.24391270720582],
            [29.36020882048075, 54.246922872092966],
            [29.361926025565708, 54.25160491353603],
            [29.36020882048075, 54.254614517246296],
            [29.35620200711702, 54.259630035397834],
            [29.356774409411628, 54.263976323049064],
            [29.361353624170476, 54.264644942909854],
            [29.370512053688515, 54.26431063432835],
            [29.38196009148521, 54.26431063432835],
            [29.388256512228395, 54.2653135510796],
            [29.390546118708414, 54.26798787583999],
            [29.388828913623627, 54.27300176621861],
            [29.388828913623627, 54.27901763085896],
            [29.388828913623627, 54.28369602914853],
            [29.392263324692806, 54.28937622723129],
            [29.396270138056536, 54.29405344920741],
            [29.401994156505282, 54.29906416947597],
            [29.40829057634909, 54.30574418074934],
            [29.404856165279966, 54.30741401404555],
            [29.401856779666673, 54.31248989199497],
            [29.399658756546557, 54.31419952029165],
            [29.393064688084962, 54.31633645606274],
            [29.38756962983456, 54.31719119961423],
            [29.382440908621163, 54.319541651526094],
            [29.380609223437034, 54.321891969438866],
            [29.378777536454322, 54.32552401552107],
            [29.37951021142726, 54.3327871445112],
            [29.37914387439048, 54.33769971007371],
            [29.3762131762972, 54.3423981362651],
            [29.370351781010015, 54.34474714836233],
            [29.365589397732606, 54.34581483698514],
            [29.361193351492147, 54.3470960255612],
            [29.356430968214738, 54.348163653929646],
            [29.35533195710417, 54.3511528628145],
            [29.357896317261293, 54.35328787853285],
            [29.36485672365899, 54.35414185406336],
            [29.37181713005657, 54.354995811607466],
            [29.37987654846404, 54.35542278363465],
            [29.385371606714443, 54.35542278363465],
            [29.397460733426215, 54.356917152004996],
            [29.40149044352927, 54.358838401571006],
            [29.405153814796904, 54.36182683434106],
            [29.408084511990808, 54.36460161247459],
            [29.410648873047137, 54.36844330401544],
            [29.412846895268046, 54.3716444390397],
            [29.417242942408052, 54.374631939212804],
            [29.421272650712353, 54.376552361402446],
            [29.427134045999537, 54.377619223548436],
            [29.4333617783235, 54.3780459608526],
            [29.43629247641678, 54.3786860578154],
            [29.439589510647465, 54.382313087479076],
            [29.437025150490342, 54.38615312156941],
            [29.435926138480625, 54.38999279683014],
            [29.434827127370056, 54.3936188273471],
            [29.428599395046092, 54.3974578038347],
            [29.42640137192592, 54.400869926106395],
            [29.42603503488914, 54.404921452862766],
            [29.4293320700192, 54.411104590504465],
            [29.4333617783235, 54.41558145252213],
            [29.437757825463336, 54.41963152597418],
            [29.44142119673097, 54.42154984195173],
            [29.447282592018155, 54.425386205009545],
            [29.447282592018155, 54.42943530899248],
            [29.44142119673097, 54.43199243230504],
            [29.436658813453562, 54.434549396437546],
            [29.43372811625966, 54.437319259776075],
            [29.430431081129598, 54.44072806534797],
            [29.4293320700192, 54.44264539386984],
            [29.42456968674179, 54.445414710420664],
            [29.41797561648167, 54.44669279273836],
            [29.415411256324546, 54.44946183589508],
            [29.417242942408052, 54.45393450887053],
            [29.42456968674179, 54.45649010243625],
            [29.428233058009255, 54.464368846145476],
            [29.432262767213103, 54.467775400714174],
            [29.43629247641678, 54.471394554115534],
            [29.439955848583622, 54.47565197166131],
            [29.44288654487815, 54.47927042898726],
            [29.452044975295394, 54.48586796703307],
            [29.455342010425454, 54.48905994156314],
            [29.455342010425454, 54.49246444028182],
            [29.454609336351893, 54.49480486924938],
            [29.44838160402793, 54.50182535035981],
            [29.44471823186103, 54.50480337257761],
            [29.44068852265724, 54.50905731244518],
            [29.44142119673097, 54.51224747753923],
            [29.44545090593465, 54.51543739262172],
            [29.447648929954312, 54.5179891460823],
            [29.44838160402793, 54.52160385593322],
            [29.449846952175278, 54.52543084805518],
            [29.452044975295394, 54.528194563628404],
            [29.45570834746229, 54.53053294573891],
            [29.462668753859987, 54.53308375581088],
            [29.46853014914717, 54.53584695337423],
            [29.47255985835085, 54.539247555330576],
            [29.47329253242441, 54.542010334709346],
            [29.47182718427723, 54.5458354148725],
            [29.470361835230506, 54.550297553189694],
            [29.465965788090728, 54.553059585231665],
            [29.4604707307397, 54.55709606543121],
            [29.4604707307397, 54.56240661427381],
            [29.461936079786426, 54.56622978067986],
            [29.466332126026884, 54.57111441689699],
            [29.474025207397574, 54.57429973374582],
            [29.47915392861097, 54.57642314011588],
            [29.485015322998947, 54.5793957232342],
            [29.489411369239406, 54.58151886340488],
            [29.493074741406303, 54.585127948895774],
            [29.492939819566175, 54.58551887408771],
            [29.49270840347009, 54.58618938363321],
            [29.486847008182963, 54.589373523269614],
            [29.480252939721538, 54.59107162855287],
            [29.477322241628258, 54.59552881879995],
            [29.478054915701875, 54.59934887894764],
            [29.477688579564415, 54.6048661117818],
            [29.4729261953878, 54.60656357135184],
            [29.462302416823206, 54.609533955627626],
            [29.454242998415737, 54.609533955627626],
            [29.44215387080459, 54.60804879001972],
            [29.4333617783235, 54.60444173609733],
            [29.425462633493908, 54.59826125954953],
            [29.42317302521508, 54.59361865427758],
            [29.419738614145786, 54.58997052112272],
            [29.415159399386937, 54.58599036726167],
            [29.403138960195008, 54.58400014419141],
            [29.39855974543599, 54.583668431053354],
            [29.392835726987244, 54.58665375306839],
            [29.392263324692806, 54.58997052112272],
            [29.392835726987244, 54.59428191507834],
            [29.389973717313353, 54.59892444570676],
            [29.384822100259896, 54.59859285397721],
            [29.377953278121424, 54.59395028557725],
            [29.373374063362405, 54.58897551930488],
            [29.36765004491383, 54.58333671521723],
            [29.365360436634887, 54.581346362644524],
            [29.36020882048075, 54.57637005583348],
            [29.357919212201978, 54.57272037854278],
            [29.347043577599095, 54.57172495494285],
            [29.340174754561303, 54.57172495494285],
            [29.331588727338044, 54.57272037854278],
            [29.323002699215237, 54.57205676610704],
            [29.315561474782385, 54.569402205747224],
            [29.313271867402932, 54.5674111732871],
            [29.30257940041912, 54.56007005778707],
            [29.29818335417849, 54.55794579885952],
            [29.296351668095156, 54.556246313117015],
            [29.292688295928087, 54.554971651820324],
            [29.285727889530563, 54.55242220961736],
            [29.27913382016976, 54.552209749280564],
            [29.275470448902126, 54.55242220961736],
            [29.27363876281879, 54.553272041971354],
            [29.27070806472551, 54.55539654371569],
            [29.268143704568388, 54.557733367301125],
            [29.26374765832793, 54.56049489572291],
            [29.260084286160918, 54.5630438334062],
            [29.25642091399402, 54.56538021902202],
            [29.25129219367983, 54.56707932435137],
            [29.245797135429598, 54.56771647063874],
            [29.236638706810936, 54.56771647063874],
            [29.2296782986146, 54.56750409034157],
            [29.221252544069728, 54.56750409034157],
            [29.217955508939667, 54.56814123033371],
            [29.215757485819495, 54.56962785014531],
            [29.21753765603802, 54.57259595194165],
            [29.227375812943535, 54.58140856245535],
            [29.228270190516923, 54.58762808217023],
            [29.228270190516923, 54.594882987759775],
            [29.23363645865578, 54.603172726140485],
            [29.23900272589526, 54.608870942140356],
            [29.237213969848824, 54.61612206338265],
            [29.220220789657844, 54.616639951472735],
            [29.2139601439456, 54.61871143728314],
            [29.2139601439456, 54.62337189409777],
            [29.20233323189325, 54.626478567931656],
            [29.193639877778253, 54.62378613082535],
            [29.18333664457049, 54.62047211649502],
            [29.17532301784314, 54.61782071095723],
            [29.16330257955059, 54.61516913274937],
            [29.154716551427782, 54.61351180902295],
            [29.149564934374325, 54.61351180902295],
            [29.138689298872123, 54.61682638902664],
            [29.122662047215783, 54.62279195458518],
            [29.11350361679854, 54.624780282783945],
            [29.107779598349964, 54.622129157834536],
            [29.099193570227214, 54.6174892730117],
            [29.088317934724955, 54.612185900758845],
            [29.080304308896814, 54.60920245023294],
            [29.071718280774178, 54.608539431349755],
            [29.059125440187017, 54.608539431349755],
            [29.048822206080047, 54.60522417505575],
            [29.036801766888118, 54.59991920470759],
            [29.029360543354585, 54.59030218299938],
            [29.02821573876531, 54.585658669412226],
            [29.02420892540175, 54.58035115038547],
            [29.02020211293734, 54.575042938880586],
            [29.01619530047293, 54.572388573673834],
            [29.00989887883037, 54.57072950796061],
            [29.002457655296666, 54.57172495494285],
            [28.995016430863757, 54.575706502753064],
            [28.987002805035615, 54.58068289050311],
            [28.97440996354908, 54.58333671521723],
            [28.957237908203012, 54.58864384663639],
            [28.94693467499542, 54.59096549865882],
            [28.936631440888277, 54.594613542780905],
            [28.926328207680683, 54.5972664600792],
            [28.910873357419632, 54.599256034738346],
            [28.895418506259205, 54.59859285397721],
            [28.887977281826124, 54.596934854859796],
            [28.882825665672044, 54.59395028557725],
            [28.884542870757002, 54.58897551930488],
            [28.891411692895417, 54.584663562373635],
            [28.896563310848308, 54.58068289050311],
            [28.903432132986723, 54.574379363317064],
            [28.90400453438184, 54.57106132631918],
            [28.901714927002388, 54.5674111732871],
            [28.89255649748452, 54.5640925688171],
            [28.882825665672044, 54.56342881518776],
            [28.879659744948242, 54.56302089640087],
            [28.879864768428035, 54.56040561582034],
            [28.878150626559034, 54.5516249064824],
            [28.875579413755645, 54.544996704467906],
            [28.871865438807788, 54.53969336735679],
            [28.867580084135454, 54.53422357904151],
            [28.85815230295782, 54.52792412688052],
            [28.851867115206574, 54.52576882814799],
            [28.85300987735104, 54.52162370257736],
            [28.859580754515378, 54.51897060171143],
            [28.8732938912637, 54.51465894465821],
            [28.882721672441278, 54.51167368451331],
            [28.889006859294057, 54.50885407232232],
            [28.89157807209739, 54.503048375091794],
            [28.88700702711367, 54.49773958709221],
            [28.880721839362423, 54.493591616505796],
            [28.878722007182034, 54.48911133551195],
            [28.87843631687042, 54.480979201459206],
            [28.875293723444088, 54.47384150646667],
            [28.869008535693013, 54.469525086411295],
            [28.858437993269433, 54.46603841508721],
            [28.849010212091798, 54.46271749897994],
            [28.840439501848607, 54.46122299904209],
            [28.832440173126884, 54.46122299904209],
            [28.82672636599864, 54.46271749897994],
            [28.821012558870564, 54.4657063351338],
            [28.811584777692985, 54.46852892492166],
            [28.801585616790646, 54.46902700869822],
            [28.792157835613068, 54.46902700869822],
            [28.78215867381249, 54.46736670586307],
            [28.771873821700467, 54.46454403590201],
            [28.770445369244555, 54.45972844400683],
            [28.77015967893317, 54.45640701635779],
            [28.772159512011854, 54.45092607096552],
            [28.780730221356748, 54.44777004203257],
            [28.78987231222277, 54.44511214521225],
            [28.797585951531403, 54.442786343976195],
            [28.796157499974015, 54.438134344714854],
            [28.791300763780157, 54.435143494559384],
            [28.786444028484823, 54.433647987854954],
            [28.784444196304435, 54.42866257069477],
            [28.785015576927435, 54.42417517653308],
            [28.78472988661582, 54.41902237784922],
            [28.782444364123876, 54.414533928067215],
            [28.77815900855319, 54.41220639000642],
            [28.781301602878045, 54.408216018235635],
            [28.784158505992878, 54.40755091851935],
            [28.792443525924455, 54.40904737771166],
            [28.800442854646406, 54.41386893082506],
            [28.809584945512427, 54.41636261486633],
            [28.819584107313005, 54.41636261486633],
            [28.825583604752637, 54.41603013242462],
            [28.833011553749884, 54.411707614771615],
            [28.831868791605586, 54.408216018235635],
            [28.824440843506636, 54.40422525760613],
            [28.81472737201767, 54.40239602943632],
            [28.81472737201767, 54.397074173990006],
            [28.825583604752637, 54.393414997685284],
            [28.83586845686483, 54.392416984012186],
            [28.842439334927462, 54.39308232915812],
            [28.850438663649186, 54.39457931628931],
            [28.859580754515378, 54.39507830038514],
            [28.865008871332066, 54.393581330937366],
            [28.867008703512454, 54.38759290851294],
            [28.867580084135454, 54.38193637370722],
            [28.8687228453814, 54.37577984710282],
            [28.8715797484964, 54.371952352007725],
            [28.871294058184787, 54.36695943035983],
            [28.869579916315843, 54.3622988224073],
            [28.865865942266453, 54.357304727054384],
            [28.863009039151507, 54.35613935090129],
            [28.856438161088874, 54.35131101130577],
            [28.859009373892434, 54.34564947690467],
            [28.86186627700738, 54.33998716255644],
            [28.861009206072822, 54.330159530982655],
            [28.85929506420382, 54.32566135653127],
            [28.859009373892434, 54.32132931614012],
            [28.86072351576138, 54.31666353169726],
            [28.865294561643452, 54.311330558764496],
            [28.871294058184787, 54.30816377937799],
            [28.878150626559034, 54.307330375882316],
            [28.889578239917, 54.307997100028786],
            [28.89614911797969, 54.30783042000468],
            [28.899577401717636, 54.30332980367649],
            [28.896434808291247, 54.2991621275271],
            [28.889578239917, 54.29566095394688],
            [28.882721672441278, 54.292826451994074],
            [28.87786493624742, 54.29032525929455],
            [28.873865271886643, 54.28732362701578],
            [28.8732938912637, 54.28248720409675],
            [28.876150794378646, 54.27815061849611],
            [28.88700702711367, 54.274647657915125],
            [28.891006691474615, 54.27047707857264],
            [28.889292549605614, 54.26280211025767],
            [28.886721336802225, 54.260465966853644],
            [28.880721839362423, 54.259798472996465],
            [28.8732938912637, 54.257295274265516],
            [28.86786577444701, 54.25379054147652],
            [28.868151464758455, 54.249951682322944],
            [28.87243681943079, 54.24644632490441],
            [28.878150626559034, 54.2434414961877],
            [28.882721672441278, 54.24043644808279],
            [28.88500719493328, 54.23626240779021],
            [28.886149956179224, 54.23091901957616],
            [28.89157807209739, 54.22724503870904],
            [28.90357706697688, 54.224238811565954],
            [28.916147441580847, 54.22273561537759],
            [28.92900350649643, 54.222067510848944],
            [28.935860074870504, 54.22173345453052],
            [28.94357371417908, 54.21922794599317],
            [28.945859236671083, 54.21338116763974],
            [28.952144423524032, 54.209538548111595],
            [28.957001159717663, 54.20502719087074],
            [28.957572540340664, 54.20034822649802],
            [28.957001159717663, 54.19700578416018],
            [28.955001327537275, 54.1955015971443],
            [28.95100166227803, 54.19282735119128],
            [28.947859068851642, 54.18981861825898],
            [28.95128735258959, 54.18664249538335],
            [28.959286682209665, 54.18413485800312],
            [28.966428940895298, 54.18313176046507],
            [28.970999985879246, 54.18313176046507],
            [28.976142412384263, 54.182295827260646],
            [28.979856386433823, 54.17861751986584],
            [28.979570696122266, 54.17309944554938],
            [28.97814224456488, 54.16089018068311],
            [28.977856554253265, 54.15085247045067],
            [28.974142580203875, 54.14466133578492],
            [28.973856889892488, 54.1414817449637],
            [28.979285005810823, 54.139138731817184],
            [28.984998812938898, 54.13863664043822],
            [28.991283999791847, 54.13579134098069],
            [28.9861415741849, 54.132443679078506],
            [28.972571283041475, 54.13102084080515],
            [28.96766098030747, 54.128143629042256],
            [28.9645362417956, 54.125789398209804],
            [28.9645362417956, 54.12134215260352],
            [28.970339327090016, 54.12029567272674],
            [28.979713541727108, 54.11977242261577],
            [28.98819497290583, 54.11872590310202],
            [28.98998053802626, 54.113231240663026],
            [28.991319711417646, 54.10145451182041],
            [28.993551667369275, 54.08731802176294],
            [28.997122795813596, 54.07553393313731],
            [29.00292588110807, 54.06427045510367],
            [29.00618429255627, 54.05399051363355],
            [29.008282574673217, 54.05405210077282],
            [29.01765678931025, 54.05405210077282],
            [29.02613822138727, 54.05274187336926],
            [29.035066044295263, 54.05116954615312],
            [29.045333040594244, 54.05090748548042],
            [29.053814472671263, 54.05143160464536],
            [29.06140312218787, 54.052479822613805],
            [29.074794856998892, 54.05300392194465],
            [29.08282989734647, 54.05300392194465],
            [29.092650502814706, 54.054838217275915],
            [29.100239152331312, 54.05536228632934],
            [29.108274192678834, 54.054576179742924],
            [29.111398931190877, 54.05090748548042],
            [29.11184532202185, 54.04540383692415],
            [29.112738104582093, 54.043044907253886],
            [29.11586284219561, 54.040161588984404],
            [29.12077314492967, 54.040161588984404],
            [29.130147359566877, 54.040947968300884],
            [29.140414355866085, 54.04435543991548],
            [29.153359698947668, 54.047238467259604],
            [29.16675143375869, 54.04854886821289],
            [29.181928732792073, 54.04959715890692],
            [29.194874075873656, 54.04907301712933],
            [29.205141073071104, 54.04776263270503],
            [29.21139054919655, 54.04330701698672],
            [29.21451528681007, 54.04330701698672],
            [29.21853280698383, 54.04068584316349],
            [29.221211153766433, 54.03596731434459],
            [29.2189791987131, 54.032034797846734],
            [29.214961677641043, 54.02888851630263],
            [29.21451528681007, 54.02521755404598],
            [29.214961677641043, 54.02233299918828],
            [29.221211153766433, 54.0218085135586],
            [29.230585368403695, 54.02102177218592],
            [29.237281235360058, 54.0218085135586],
            [29.24174514726309, 54.0241686483937],
            [29.247101840828066, 54.0254797767214],
            [29.256476055465328, 54.02679086318835],
            [29.263618313252664, 54.02679086318835],
            [29.270314181107324, 54.02259524005052],
            [29.27388531045017, 54.01735011551261],
            [29.274778092112058, 54.01367813475707],
            [29.275224483841498, 54.00974350967482],
            [29.28192035079769, 54.00607085756275],
            [29.287277044362895, 54.00580851305506],
            [29.297097649831073, 54.00607085756275],
            [29.302007952565077, 54.003972053613495],
            [29.30736464613028, 54.00003651126758],
            [29.311828558033312, 53.997675007249995],
            [29.316738860767316, 53.997150210211316],
            [29.32611307450628, 53.99662540655709],
            [29.331469768969725, 53.99662540655709],
            [29.33766660559189, 53.99662540655709],
            [29.33559554070183, 53.99778208127805],
            [29.33648991827522, 54.000936341838894],
            [29.349905587273156, 54.01302546405401],
            [29.375842546796264, 54.022484066586514],
            [29.402673883892703, 54.03036459185262],
            [29.422350198602885, 54.0335163837741],
            [29.438448999421894, 54.04086963652463],
            [29.436660245174266, 54.05347218709187],
            [29.435765866701445, 54.066595779671616],
            [29.435451559291835, 54.06698769293507],
            [29.42861084341581, 54.07551745456698],
            [29.434871489128057, 54.084961844213865],
            [29.44202651151437, 54.08653570006254],
            [29.44560402360696, 54.09755102096295],
            [29.441132133940926, 54.10856341636867],
            [29.42861084341581, 54.117476071963154],
            [29.42861084341581, 54.128483177556745],
            [29.44023775546816, 54.13215156344387],
            [29.44918153569938, 54.139487359454165],
            [29.45097029174559, 54.14996481472451],
            [29.446498401180406, 54.15939225844602],
            [29.435765866701445, 54.16567602752673],
            [29.442920889987136, 54.17457640108006],
            [29.446498401180406, 54.185568336009965],
            [29.459914070178343, 54.19289467025288],
            [29.46796347103742, 54.20335860871296],
            [29.45365342446604, 54.209112645632274],
            [29.44381526756058, 54.21120482394355],
            [29.42771646494299, 54.2200954002825],
            [29.419840233040418, 54.23482848344787],
          ],
        ],
      },
      properties: {
        shapeName: "Krupki",
        shapeISO: "",
        shapeID: "67162791B85718992399445",
        shapeGroup: "BLR",
        shapeType: "ADM2",
      },
    },
  ],
};
